package com.arena_web.ui.localization

object AppStringsDE : AppStrings {

    // language selector
    override val headerProfileLanguage = "Sprache"
    override val headerProfileLanguageRecommended = "Empfohlen"

    // common
    override val commonSeeAll = "Alle anzeigen"
    override val commonNo = "Nein"
    override val commonYes = "Ja"
    override val commonConfirm = "Bestätigen"
    override val commonSend = "Senden"
    override val commonError = "Fehler"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Stummschaltung aufheben"
    override val chatMenuMute = "Stummschalten"
    override val chatMenuInviteMembers = "Mitglieder einladen"
    override val chatMenuLeaveGroup = "Gruppe verlassen"
    override val chatMenuDeleteChat = "Chat löschen"
    override fun chatRemoveMemberTitle(name: String) = "$name entfernen?"
    override fun chatRemoveMemberWarning(name: String) = "$name aus der Gruppe entfernen? Diese Aktion kann nicht rückgängig gemacht werden."
    override val chatRemoveMemberAction = "Entfernen"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name tippt..."
    override fun chatTypingMany(count: Int) = "$count Personen tippen..."
    override fun chatMembersCount(count: Int) = "$count Mitglieder"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count Mitglieder, $online online"
    override val chatOnline = "Online"
    override val chatOffline = "Offline"
    override val chatEditCommunityTitle = "Community bearbeiten"
    override val chatCommunityNameLabel = "Community-Name"
    override val chatCommunityNamePlaceholder = "Community-Namen eingeben..."
    override val chatSaving = "Wird gespeichert..."
    override val chatMessageInputPlaceholder = "Nachricht schreiben..."
    override val chatInviteMembersTitle = "Mitglieder einladen"
    override val chatSearchFriendsPlaceholder = "Freunde suchen..."
    override val chatNoFriendsToInvite = "Keine Freunde zum Einladen"
    override val chatNoResults = "Keine Ergebnisse"
    override val chatInviting = "Wird eingeladen..."
    override val chatInvite = "Einladen"
    override fun chatInviteCount(count: Int) = "Einladen ($count)"
    override val chatPanelTitle = "Arena Chat"
    override val chatSearchPlaceholder = "Chat durchsuchen"
    override val chatFilterAll = "Alle"
    override val chatFilterDirect = "Direkt"
    override val chatFilterCommunity = "Community"
    override val chatNoChatsFound = "Keine Chats gefunden"
    override val chatNoConversationsYet = "Noch keine Unterhaltungen"
    override val chatNewChatTitle = "Neuer Chat"
    override val chatTabDirectMessage = "Direktnachricht"
    override val chatTabCommunity = "Community"
    override val chatSearchPeoplePlaceholder = "Suche Personen, denen du folgst..."
    override val chatNotFollowingAnyone = "Du folgst noch niemandem"
    override val chatCreating = "Wird erstellt..."
    override val chatCreateCommunity = "Community erstellen"
    override val chatSelectConversation = "Wähle eine Unterhaltung"
    override fun chatReplyTo(name: String) = "Antwort an $name"
    override val chatUnknownSender = "Unbekannt"
    override val chatUploading = "Wird hochgeladen..."
    override val chatEditingMessage = "Nachricht bearbeiten"
    override val chatSearchInChatPlaceholder = "Im Chat suchen..."
    override fun chatSearchResultsFound(count: Int) = "$count gefunden"
    override val chatGroupInfoTitle = "Gruppeninfo"
    override val chatUserInfoTitle = "Nutzerinfo"
    override val chatDeleteChatAction = "Chat löschen"
    override val chatDeleteGroupAction = "Gruppe löschen"
    override val chatLeaveGroupAction = "Gruppe verlassen"
    override val chatLastSeenRecently = "zuletzt kürzlich online"
    override val chatNotificationsLabel = "Benachrichtigungen"
    override val chatTabMembers = "Mitglieder"
    override val chatTabMedia = "Medien"
    override val chatTabFiles = "Dateien"
    override val chatTabLinks = "Links"
    override val chatLoading = "Wird geladen..."
    override val chatNoMediaYet = "Noch keine Medien"
    override val chatNoFilesYet = "Noch keine Dateien"
    override val chatUnknownFile = "Unbekannte Datei"
    override val chatNoLinksYet = "Noch keine Links"
    override val chatNoMembers = "Keine Mitglieder"
    override val chatRoleOwner = "Besitzer"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "bearbeitet"
    override val chatFileFallback = "Datei"
    override val chatMenuReply = "Antworten"
    override val chatMenuPin = "Anpinnen"
    override val chatEmptyTitle = "Noch keine Chats"
    override val chatEmptySubtitle = "Starte eine Unterhaltung, um deine Nachrichten hier zu sehen."
    override val chatUnnamed = "Unbenannt"
    override val chatNoMessagesYet = "Noch keine Nachrichten"
    override val chatRoomEmptyTitle = "Noch keine Nachrichten"
    override val chatRoomEmptySubtitle = "Sag Hallo und starte die Unterhaltung."
    override fun chatMembersHeader(count: Int) = "Mitglieder ($count)"
    override val chatNoMediaSharedYet = "Noch keine Medien geteilt"
    override val chatNoFilesSharedYet = "Noch keine Dateien geteilt"
    override val chatNoLinksSharedYet = "Noch keine Links geteilt"

    // widget
    override val widgetDismiss = "Schließen"
    override val widgetSomethingWentWrong = "Etwas ist schiefgelaufen"
    override val widgetTryAgain = "Erneut versuchen"
    override val widgetCookieTitle = "Wir verwenden Cookies"
    override val widgetCookieMessage = "Diese Website verwendet Cookies, um dir das beste Erlebnis zu bieten."
    override val widgetCookieDecline = "Ablehnen"
    override val widgetCookieAccept = "Akzeptieren"
    override val widgetAddInterval = "Intervall hinzufügen"
    override val widgetSendMessage = "Nachricht senden"
    override val widgetPrevious = "Zurück"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Aktiv"
    override val widgetStatusDebtor = "Schuldner"
    override val widgetStatusInactive = "Inaktiv"
    override val widgetUnpaid = "unbezahlt"
    override val widgetStatusInProgress = "Läuft"
    override val widgetStatusUpcoming = "Bevorstehend"
    override val widgetStatusPending = "Ausstehend"
    override val widgetStatusCompleted = "Abgeschlossen"
    override fun widgetFieldLabel(number: String) = "Platz $number"
    override val widgetYearly = "Jährlich"
    override val widgetAllFields = "Alle Plätze"
    override val widgetPreviousMonth = "Vorheriger Monat"
    override val widgetNextMonth = "Nächster Monat"
    override val widgetSortAscending = "Aufsteigend sortieren"
    override val widgetSortDescending = "Absteigend sortieren"
    override val widgetChecked = "Ausgewählt"

    // form
    override val formSelectPlaceholder = "Auswählen..."

    // common
    override val commonCancel = "Abbrechen"
    override val commonSave = "Speichern"
    override val commonDelete = "Löschen"
    override val commonEdit = "Bearbeiten"
    override val commonNext = "Weiter"
    override val commonRetry = "Erneut versuchen"
    override val commonSearch = "Suchen"

    // event
    override val eventMatchEndedTitle = "DAS MATCH IST BEENDET"
    override val eventMatchEndedSubtitle = "Bewerte Spieler, um ihre persönlichen Rankings zu aktualisieren."
    override val eventTabMatchInfo = "Match-Info"
    override val eventTabLineups = "Aufstellungen"
    override val eventTabMedia = "Medien"
    override val eventCreateTeam = "Team erstellen"
    override val eventCancelEventQuestion = "Event absagen?"
    override val eventDeleteEventQuestion = "Event löschen?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" wird als abgesagt markiert."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" wird endgültig gelöscht."
    override val eventCancelNoticeParticipants = "Andere Teilnehmer werden benachrichtigt. Chat und Verlauf bleiben verfügbar."
    override val eventDeleteNoticeMedia = "Event-Bild und Chat werden ebenfalls entfernt."
    override val eventKeepEvent = "Event behalten"
    override val eventCancelling = "Wird abgesagt..."
    override val eventDeleting = "Wird gelöscht..."
    override val eventCancelEvent = "Event absagen"
    override val eventMatchPerformanceTitle = "Match-Leistung"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Statistik"
    override val eventProPlusStatDescription = "Detaillierte Schussgenauigkeit, Passquote und Ballbesitz."
    override val eventLoadingMedia = "Medien werden geladen..."
    override val eventDeleteMediaQuestion = "Medien löschen?"
    override val eventDeleteMediaMessage = "Diese Datei wird für alle aus dem Event entfernt."
    override val eventNoMediaYet = "Noch keine Medien"
    override val eventNoMediaDescription = "Fotos und Videos von diesem Match erscheinen hier."
    override val eventInviteTeamTitle = "Team einladen"
    override val eventSearchTeamsLabel = "Teams suchen"
    override val eventSearchTeamsPlaceholder = "Teamnamen eingeben..."
    override val eventSearching = "Wird gesucht..."
    override val eventNoTeamsFound = "Keine Teams gefunden"
    override fun eventTeamRating(rating: String) = "Bewertung $rating"
    override fun eventTeamMembersCount(count: Int) = "$count Mitglieder"
    override val eventInviteStatusAccepted = "Angenommen"
    override val eventInviteStatusDeclined = "Abgelehnt"
    override val eventInviteStatusInvited = "Eingeladen"
    override val eventInvite = "Einladen"
    override val eventStartEventQuestion = "Event starten?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" geht live."
    override val eventStartNotice = "Die Anmeldung wird geschlossen und das Match beginnt."
    override fun eventPendingRequestOne(count: Int) = "$count offene Anfrage"
    override fun eventPendingRequestsMany(count: Int) = "$count offene Anfragen"
    override val eventPendingRequestsSubtitle = "Diese Spieler möchten beitreten, wurden aber noch nicht bestätigt."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count Spieler ohne Team"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count Spieler ohne Team"
    override val eventTeamlessSubtitle = "Sie sind bestätigt, aber keinem Team zugeteilt."
    override val eventStarting = "Wird gestartet..."
    override val eventStartAnyway = "Trotzdem starten"
    override val eventMonthJanuary = "Januar"
    override val eventMonthFebruary = "Februar"
    override val eventMonthMarch = "März"
    override val eventMonthApril = "April"
    override val eventMonthMay = "Mai"
    override val eventMonthJune = "Juni"
    override val eventMonthJuly = "Juli"
    override val eventMonthAugust = "August"
    override val eventMonthSeptember = "September"
    override val eventMonthOctober = "Oktober"
    override val eventMonthNovember = "November"
    override val eventMonthDecember = "Dezember"
    override val eventVs = "vs"
    override val eventTeamsLabel = "Teams"
    override val eventPlayersLabel = "Spieler"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Beendet"
    override val eventLeadersEmptyWinGame = "Gewinne ein Spiel, um in der Rangliste aufzusteigen."
    override val eventLeadersEmptyFirstScore = "Triff als Erster und führe die Rangliste an."
    override val eventLeadersEmptyTakeSet = "Hol dir einen Satz und sichere dir die Spitze."
    override val eventLeadersEmptyFirstAssist = "Liefere als Erster den spielentscheidenden Pass."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Spieler"
    override val eventCreateTeamSubtitle = "Stelle deinen Kader für das Match auf"
    override val eventTeamNameLabel = "Teamname"
    override val eventTeamNameRequired = "Teamname ist erforderlich"
    override val eventTeamColorLabel = "Teamfarbe"
    override val eventTeamColorSubtitle = "Wähle die Farbe deines Teams"
    override val eventTeamNamePlaceholder = "Teamnamen eingeben..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Spieler"
    override val eventChatWaitingApproval = "Warten auf Bestätigung"
    override val eventChatConfirmingSpot = "Dein Platz wird bestätigt"
    override val eventChatLocked = "Chat ist gesperrt"
    override val eventChatWaitingApprovalSubtitle = "Sobald der Admin deine Anfrage bestätigt, kannst du mit dem Team chatten."
    override val eventChatConfirmingSpotSubtitle = "Deine Beitrittsanfrage wird bearbeitet. Der Chat wird freigeschaltet, sobald du dabei bist."
    override val eventChatPrivateSubtitle = "Dies ist ein privates Event. Stelle eine Beitrittsanfrage und warte auf die Bestätigung des Admins."
    override val eventChatLockedSubtitle = "Du musst diesem Match beitreten, um die Unterhaltung zu sehen und mit anderen Spielern zu schreiben."
    override val eventJoinEvent = "Event beitreten"
    override val eventChatNoMessages = "Noch keine Nachrichten"
    override val eventChatNoMessagesSubtitle = "Starte die Unterhaltung mit deinem Team."
    override val eventTeamSectionTitle = "Team"
    override val eventDeleteTeam = "Team löschen"
    override val eventViewProfile = "Profil ansehen"
    override val eventRemoveAdmin = "Admin entfernen"
    override val eventMakeAdmin = "Zum Admin machen"
    override val eventRemoveFromTeam = "Aus dem Team entfernen"
    override val eventRemoveFromEvent = "Aus dem Event entfernen"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count Teams"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max Spieler"
    override fun eventPlayersCount(count: Int) = "$count Spieler"
    override val eventStatusLive = "Live"
    override val eventLeave = "Verlassen"
    override val eventStart = "Starten"
    override val eventJoin = "Beitreten"
    override val eventStatusPending = "Ausstehend"
    override val eventStatusCanceled = "Abgesagt"
    override val eventPendingApprovalBadge = "Bestätigung ausstehend"
    override val eventRatePerformanceTitle = "Leistung bewerten"
    override val eventRateVoteCounts = "Deine Stimme zählt!"
    override val eventCommunityRating = "Community-Bewertung"
    override val eventSubmitRating = "Bewertung absenden"
    override val eventSubmitting = "Wird gesendet..."
    override val eventAddMediaTitle = "Medien hinzufügen"
    override val eventUploadMedia = "Medien hochladen"
    override val eventDropMediaHere = "Lege dein Foto und Video hier ab"
    override val eventMaxFileSize = "max. 30 MB"
    override val eventSelectedLabel = "Ausgewählt"
    override val eventClearAll = "Alle entfernen"
    override val eventAddToTeam = "Zum Team hinzufügen"
    override val eventMakeSubstitution = "Auswechseln"
    override val eventViewProfileSheet = "Profil ansehen"
    override fun eventSwapWith(name: String) = "$name tauschen mit"
    override val eventEndMatch = "Match beenden"
    override val eventReset = "Zurücksetzen"
    override val eventLeadersEmptyWinGameShort = "Gewinne ein Spiel, um in der Rangliste aufzusteigen"
    override val eventLeadersEmptyScoreFirst = "Triff zuerst und führe die Rangliste an"
    override val eventLeadersEmptyTakeSetShort = "Hol dir einen Satz und sichere dir die Spitze"
    override val eventLeadersEmptyWinningAssist = "Gib die entscheidende Vorlage"
    override val eventRatePlayersSubtitle = "Bewerte Spieler, um die Top-Rankings zu aktualisieren"
    override val eventGenericError = "Etwas ist schiefgelaufen"
    override val eventDeleteTeamQuestion = "Team löschen?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" wird aus diesem Event entfernt. Die zugewiesenen Spieler sind danach keinem Team mehr zugeteilt."
    override val eventPlayersTitle = "Spieler"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total bestätigt)"
    override val eventAwaitingPlayers = "Warten auf Spieler"
    override val eventAwaitingPlayersSubtitle = "Tritt dem Event jetzt bei, um Teams zu bilden."
    override val eventAssignToTeam = "Einem Team zuweisen"
    override val eventFormatLabel = "Format:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Timeline"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Trainer"
    override val eventSaving = "Wird gespeichert..."
    override val eventCreating = "Wird erstellt..."
    override val eventSaveChanges = "Änderungen speichern"
    override val eventCreateEvent = "Event erstellen"
    override val eventEditEventTitle = "Event bearbeiten"
    override val eventErrorTitleRequired = "Titel ist erforderlich"
    override val eventErrorSportRequired = "Sportart ist erforderlich"
    override val eventErrorSportNameRequired = "Name der Sportart ist erforderlich"
    override val eventErrorFormatRequiredPro = "Format ist für Pro-Events erforderlich"
    override val eventErrorStartTimeRequired = "Startzeit ist erforderlich"
    override val eventErrorEndTimeRequired = "Endzeit ist erforderlich"
    override val eventErrorEndAfterStart = "Die Endzeit muss nach der Startzeit liegen"
    override val eventErrorStartInPast = "Die Startzeit darf nicht in der Vergangenheit liegen"
    override val eventErrorSelectAddress = "Wähle eine Adresse"
    override val eventErrorAddressCity = "Wähle eine gültige Adresse mit Stadt"
    override val eventErrorCoverRequired = "Titelbild ist erforderlich"
    override val eventErrorSignInEdit = "Bitte melde dich an, um Events zu bearbeiten"
    override val eventErrorSignInCreate = "Bitte melde dich an, um Events zu erstellen"
    override val eventErrorUploadImage = "Bild konnte nicht hochgeladen werden"
    override val eventErrorSaveChanges = "Änderungen konnten nicht gespeichert werden"
    override val eventErrorCreateEvent = "Event konnte nicht erstellt werden"
    override val eventAddressLabel = "Adresse"
    override val eventAddressPlaceholder = "Nach Adresse suchen..."
    override val eventTitleLabel = "Titel"
    override val eventTitlePlaceholder = "z. B. Sonntagsfußball"
    override val eventSportNameLabel = "Sportart"
    override val eventSportNamePlaceholder = "Sportart eingeben"
    override val eventMaxPlayersLabel = "Max. Spieler"
    override val eventMaxPlayersPlaceholder = "z. B. 20"
    override val eventDateLabel = "Datum"
    override val eventTimeFromLabel = "Von"
    override val eventTimeToLabel = "Bis"
    override val eventChooseOnMap = "Auf der Karte auswählen"
    override val eventConfirmLocation = "Standort bestätigen"
    override val eventAddPhoto = "Foto hinzufügen"
    override val eventSportLabel = "Sport"
    override val eventLoading = "Wird geladen..."
    override val eventSelectSportPlaceholder = "Sportart auswählen"
    override val eventCommunityLabel = "Community"
    override val eventCommunityNone = "Keine (Öffentlich)"
    override val eventUnnamedGroup = "Unbenannte Gruppe"
    override val eventFormatFieldLabel = "Format"
    override val eventSelectPlaceholder = "Auswählen"
    override val eventCostLabel = "Kosten"
    override val eventPrivateLabel = "Privat"
    override val eventPrivateInfoDescription = "Verwalte dein Team, indem du Beitrittsanfragen manuell bestätigst oder Teilnehmer entfernst."

    // wallet
    override val walletTopUpTitle = "Wallet aufladen"
    override val walletSelectAmount = "Betrag auswählen"
    override val walletOr = "oder"
    override val walletCustomAmount = "Eigener Betrag"
    override val walletEnterAmountPlaceholder = "Betrag eingeben"
    override val walletProcessing = "Wird verarbeitet…"
    override val walletTopUpAction = "Aufladen"

    // nav
    override val navDashboard = "Dashboard"
    override val navClients = "Kunden"
    override val navChat = "Chat"
    override val navSchedule = "Zeitplan"
    override val navClubSettings = "Club-Einstellungen"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navPeople = "Leute"
    override val navProfile = "Profil"
    override val navStatistic = "Statistik"
    override val navTeam = "Team"
    override val navMedia = "Medien"
    override val navWeek = "Woche"
    override val navMonth = "Monat"
    override val navYear = "Jahr"

    // modal
    override val modalDecline = "Ablehnen"
    override val modalCompleteSession = "Sitzung abschließen"
    override val modalTimeAlt = "Zeit"
    override val modalPriceAlt = "Preis"
    override val modalBookings = "Buchungen"
    override val modalTotalSpent = "Gesamtausgaben"
    override val modalSendMessage = "Nachricht senden"
    override val modalAddNote = "Notiz hinzufügen"
    override val modalAdminNotes = "Admin-Notizen"
    override val modalAdminNotesPrivacy = "Privat – nur für Admins sichtbar"
    override val modalWriteNotePlaceholder = "Notiz schreiben..."
    override val modalAdd = "Hinzufügen"
    override val modalBookingHistory = "Buchungsverlauf"
    override val modalNoBookingsYet = "Noch keine Buchungen"
    override val modalFieldFallback = "Platz"
    override val modalStatusConfirmed = "Bestätigt"
    override val modalStatusPending = "Ausstehend"
    override val modalStatusCompleted = "Abgeschlossen"
    override val modalStatusCancelled = "Storniert"
    override val modalPaid = "Bezahlt"
    override val modalUnpaid = "Unbezahlt"

    // feed
    override val feedClubBadge = "Club"
    override fun feedAddAllPhotos(count: Int) = "Alle $count Foto(s) hinzufügen"
    override val feedUploadFailed = "Upload fehlgeschlagen"
    override val feedCreatePostFailed = "Post konnte nicht erstellt werden"
    override val feedCreatePostTitle = "Post erstellen"
    override val feedChooseLayoutSubtitle = "Wähle ein Layout für deinen Post"
    override val feedFileTooLarge = "Datei zu groß (max. 50 MB)"
    override val feedChooseLayout = "Layout auswählen"
    override val feedCreating = "Wird erstellt..."
    override val feedAddPhoto = "Foto hinzufügen"
    override val feedCityLabel = "Stadt"
    override val feedEnterCityPlaceholder = "Stadtnamen eingeben..."
    override val feedPostContentLabel = "Post-Inhalt"
    override val feedPostContentPlaceholder = "Schreib etwas zu diesem Post..."
    override val feedOptional = "(Optional)"
    override val feedPickPhotoFirst = "Wähle zuerst ein Foto"
    override val feedCreateStoryFailed = "Story konnte nicht erstellt werden"
    override val feedCreateStoriesTitle = "Stories erstellen"
    override val feedCreateStoriesSubtitle = "Erstelle und teile deine Momente"
    override val feedFileTooLargeStory = "Datei zu groß (max. 30 MB)"
    override val feedDropContentHere = "Lege deinen Inhalt hier ab"
    override val feedMaxStorySize = " max. 30 MB"
    override val feedFollowingSection = "Folge ich"
    override val feedFollowersSection = "Follower"
    override val feedSearching = "Wird gesucht…"
    override val feedNoResults = "Keine Ergebnisse"
    override val feedLoadingMore = "Mehr wird geladen…"
    override val feedThisUser = "diesem Nutzer"
    override fun feedUnfollowTitle(name: String) = "$name entfolgen?"
    override val feedUnfollowSubtitle = "Du kannst jederzeit wieder folgen."
    override val feedUnfollow = "Entfolgen"
    override fun feedRemoveTitle(name: String) = "$name entfernen?"
    override val feedRemoveSubtitle = "Die Person wird nicht benachrichtigt, sieht deine Posts aber nicht mehr."
    override val feedRemove = "Entfernen"
    override val feedFollow = "Folgen"
    override val feedDeleted = "Gelöscht"
    override val feedNotFollowingTitle = "Du folgst noch niemandem"
    override val feedNotFollowingBody = "Folge Spielern, um ihre neuesten Match-Posts, Highlights und Stories in deinem Feed zu sehen."
    override val feedNoFollowersTitle = "Noch keine Follower"
    override val feedNoFollowersBody = "Teile deine Match-Posts und Stories, um von der Community entdeckt zu werden."
    override val feedDiscoverPlayers = "Spieler entdecken"

    // dropdown
    override val dropdownAllCities = "Alle Städte"
    override val dropdownSelectedAlt = "Ausgewählt"

    // page
    override val pageScheduleTitle = "Zeitplan"
    override val pageScheduleComingSoon = "Zeitplan-Ansicht kommt bald"
    override val pageEventsSeoTitle = "Sport-Events"
    override val pageEventsSeoDescription = "Entdecke Sport-Events in deiner Nähe und mach mit — Fußball, Tennis, Basketball, Padel und mehr. Erstelle dein eigenes Spiel und lade Spieler auf Arena ein."
    override val pageEventsTitle = "Events"
    override val pageCreateEvent = "Event erstellen"
    override val pageNoEventsYet = "Noch keine Events"
    override val pageNotFoundTitle = "Ups, Seite nicht gefunden"
    override val pageNotFoundBody = "Bitte überprüfe die Adresse auf Tippfehler oder kehre zur Haupt-Arena zurück."
    override val pageBackToArena = "Zurück zur Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Wird geladen..."
    override val pageSomethingWentWrong = "Etwas ist schiefgelaufen"
    override fun pageUnfollowTitle(name: String) = "$name entfolgen"
    override val pageRemoveFollowerTitle = "Follower entfernen?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Wir benachrichtigen $name nicht über diese Änderung."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "Sieh, was in der Arena-Sport-Community los ist — Match-Ergebnisse, Highlights und Momente von Spielern in deiner Nähe."
    override val pageNoPostsYet = "Noch keine Posts"
    override val pageLoadingMore = "Mehr wird geladen..."
    override val pagePeopleSeoTitle = "Spieler finden"
    override val pagePeopleSeoDescription = "Entdecke Sportler in deiner Nähe, matche mit Spielern auf deinem Level und bilde ein Team für dein nächstes Spiel auf Arena."
    override val pagePeopleTitle = "Leute"
    override val pageSquadUpTitle = "Stell dein Team auf"
    override val pageSquadUpSubtitle = "Finde Partner, verbinde dich mit Spielern und starte das Spiel."
    override val pagePeopleLoadFailed = "Spieler konnten nicht geladen werden"
    override val pagePeopleCaughtUpTitle = "Du bist vorerst auf dem neuesten Stand"
    override val pagePeopleCaughtUpSubtitle = "Schau später wieder vorbei für mehr Spieler."
    override val pageRefresh = "Aktualisieren"
    override val pageClientsTitle = "Kunden"
    override fun pageClientsTotal(total: Int) = "$total Kunden insgesamt"
    override val pageActiveClients = "Aktive Kunden"
    override val pageTotalBookings = "Buchungen gesamt"
    override val pageTotalRevenue = "Gesamtumsatz"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Aktiv"
    override val pageStatusDebtor = "Schuldner"
    override val pageStatusAll = "Alle Status"
    override val pageStatusInactive = "Inaktiv"
    override val pageAddNewClient = "Neuen Kunden hinzufügen"
    override val pageColName = "Name"
    override val pageColRevenue = "Umsatz"
    override val pageColStatus = "Status"
    override val pageColLastVisit = "Letzter Besuch"
    override val pageColActions = "Aktionen"
    override val pageUnpaidSuffix = "unbezahlt"
    override val pagePrevious = "Zurück"
    override val pagePageLabel = "Seite"
    override val pageOfLabel = "von"
    override val pageBackToEvents = "Zurück zu den Events"
    override val pageResetTimerTitle = "Timer zurücksetzen?"
    override val pageResetTimerMessage = "Der Match-Timer wird auf 00:00 zurückgesetzt. Erfasste Statistiken bleiben erhalten."
    override val pageResetTimerConfirm = "Zurücksetzen"
    override val pageResetting = "Wird zurückgesetzt..."
    override val pageEndMatchTitle = "Match beenden?"
    override val pageEndMatchMessage = "Das Event wird als beendet markiert und die Ergebnisse werden festgeschrieben."
    override val pageEndMatchConfirm = "Match beenden"
    override val pageEnding = "Wird beendet..."
    override val pageAddMedia = "Medien hinzufügen"
    override val pageBook = "Buchen"
    override val pageCourtRules = "Platzregeln"
    override val pageNoCourtRules = "Keine Platzregeln angegeben."
    override val pageLeaveReview = "Bewertung schreiben"
    override val pageNoReviewsYet = "Noch keine Bewertungen."
    override val pageSportFootball = "Fußball"
    override val pageSportBasketball = "Basketball"
    override val pageSportTennis = "Tennis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Club"
    override fun pageReviewExperienceTitle(sportName: String) = "Wie war dein $sportName-Erlebnis?"
    override val pageWriteReviewPlaceholder = "Schreibe deine Bewertung..."
    override val pagePosting = "Wird veröffentlicht..."
    override val pagePostReview = "Bewertung veröffentlichen"
    override val pageLoadMore = "Mehr laden"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Deine Sportkarriere auf einen Blick — Statistiken, Bewertungen und Erfolge in Fußball, Tennis, Basketball und mehr auf Arena."
    override val pageEventsTab = "Events"
    override val pageClubsTab = "Clubs"
    override val pageFilterLocation = "Ort"
    override val pageUnnamedCommunity = "Unbenannt"
    override val pageFilterCommunity = "Community"
    override val pageFilterAll = "Alle"
    override val pageFilterCalendar = "Kalender"
    override val pageAddEvent = "Event hinzufügen"
    override val pageAddClub = "Club hinzufügen"
    override val pageMap = "Karte"
    override val pageOwnTheArena = "EROBERE DIE ARENA"
    override val pageArenaBannerSubtitle = "Deine Arena wartet. Buche sofort — spiele selbstbewusst."
    override val pageLoadingMoreEvents = "Weitere Events werden geladen..."
    override val pageLoadingMoreClubs = "Weitere Clubs werden geladen..."
    override val pageNoClubsYet = "Noch keine Clubs"
    override val pageClubsWillAppear = "Clubs erscheinen hier"
    override val pageEventsMapTitle = "Event-Karte"
    override val pageClubsMapTitle = "Club-Karte"
    override val pageDeleteClub = "Club löschen"
    override val pageAddBanner = "Banner hinzufügen"
    override val pageRulePlaceholder = "z. B. Sportkleidung erforderlich"
    override val pageAddRule = "Regel hinzufügen"
    override val pageEditServices = "Leistungen bearbeiten"
    override val pageManageServices = "Leistungen verwalten"
    override val pageAmenityParking = "Parkplatz"
    override val pageAmenityCafe = "Café"
    override val pageAmenityWifi = "WLAN"
    override val pageAmenityReception = "Empfang"
    override val pageAmenityShower = "Dusche"
    override val pageAmenityFirstAid = "Erste Hilfe"
    override val pageReviewsLabel = "Bewertungen:"
    override val pageAvgRatingLabel = "Ø Bewertung:"
    override val pageReviewsPlaceholderNote = "Bewertungen erscheinen hier, sobald Nutzer Feedback geben."
    override val pageClubComposePrompt = "Was gibt's Neues in deinem Club?"
    override val pageClubNoPostsHint = "Teile ein Foto und einen kurzen Gedanken, um den Club aktiv zu halten."
    override val pageComposePostTitle = "Post verfassen"
    override val pagePostContentPlaceholder = "Post-Inhalt..."
    override fun pageAddImageSlot(slot: Int) = "Bild $slot hinzufügen"
    override val pagePostAction = "Posten"
    override val pageEditClubInfo = "Club-Info bearbeiten"
    override val pageClubNameLabel = "Clubname"
    override val pageAddressLabel = "Adresse"
    override val pageSearchAddressPlaceholder = "Nach Adresse suchen"
    override val pageSaveChanges = "Änderungen speichern"

    // account
    override val accountRequiredTitle = "Konto erforderlich"
    override val accountRequiredDescription = "Diese Funktion ist nur für registrierte Spieler. Melde dich mit Google oder Apple an, um fortzufahren."
    override val accountRequiredTermsPrefix = "Indem du fortfährst, akzeptierst du unsere "
    override val accountRequiredTerms = "Nutzungsbedingungen"
    override val accountRequiredPrivacy = "Datenschutz"

    // avatar
    override val avatarGenTitle = "KI-Avatar"
    override val avatarGenErrorFileType = "Nur JPEG-, PNG- und WebP-Dateien sind erlaubt"
    override val avatarGenErrorFileSize = "Die Datei darf höchstens 30 MB groß sein"
    override val avatarGenGenerating = "Wird generiert…"
    override val avatarGenGenerate = "Generieren"
    override fun avatarGenGenerateWithPrice(price: String) = "Generieren · $price"
    override val avatarGenGeneratedLook = "Generierter Look"
    override val avatarGenDropPhotoHere = "Lege dein Foto hier ab"
    override val avatarGenMaxFileSize = "max. 30 MB"
    override val avatarGenReadyToGenerate = "Bereit zum Generieren"
    override val avatarGenCustomPrompt = "Eigener Prompt"
    override val avatarGenPromptPlaceholder = "Füge Details hinzu, um den Stil festzulegen ..."
    override val avatarGenInfoDefaultBehavior = "Standardmäßig schneidet die KI dich aus dem Foto aus und platziert dich auf der Karte."
    override val avatarGenInfoPromptIntro = "Im Prompt kannst du außerdem Folgendes anfordern:"
    override val avatarGenInfoBulletZoom = "Die Figur vergrößern oder verkleinern"
    override val avatarGenInfoBulletObject = "Ein Objekt hinzufügen oder entfernen (z. B. Sonnenbrille, Trikot, Ball, Mütze)"
    override val avatarGenOptionalBadge = "(Optional)"

    // card
    override val cardLifeTitle = "Erwecke deine Karte zum Leben"
    override val cardLifeSubtitle = "Erstelle deine visuelle Identität"
    override val cardLifeMyStyles = "Meine Styles"
    override val cardLifeSelectToGenerate = "Zum Generieren auswählen"
    override val cardLifeActiveCards = "Aktive Profilkarten"
    override val cardLifeDragToReorder = "Zum Sortieren ziehen"
    override val cardLifeNoTemplates = "Noch keine Kartenvorlagen. Hol dir eine im Karten-Shop."
    override val cardLifeCreatePhoto = "Foto erstellen"
    override val cardLifeDeleteCardTitle = "Karte löschen?"
    override val cardLifeDeleteCardMessage = "Das entfernt die Karte aus deiner Galerie. Die Vorlage bleibt in deinen Styles."

    // wallet
    override val walletTitle = "Mein Wallet"
    override val walletCredits = "Credits"
    override val walletSignInToBuy = "Bitte melde dich an, um Credits zu kaufen."
    override fun walletCreditsAdded(amount: Int) = "$amount Credits wurden deinem Wallet gutgeschrieben."
    override val walletPurchaseFailed = "Kauf fehlgeschlagen. Versuch es erneut."
    override fun walletBuyFor(price: String) = "Für $price kaufen"
    override val walletBackToPackages = "Zurück zu den Paketen"
    override val walletSelectedPack = "Ausgewähltes Paket"
    override fun walletOneTimePurchase(currency: String) = "$currency · Einmaliger Kauf"
    override val walletCurrentBalance = "Aktuelles Guthaben"
    override val walletNewBalance = "Neues Guthaben"
    override val walletSecuredNote = "Sicher · Keine wiederkehrenden Kosten"
    override val walletPaymentMethod = "Zahlungsmethode"
    override val walletOrPayWithCard = "Oder mit Karte zahlen"
    override val walletCardNumber = "Kartennummer"
    override val walletExpiryDate = "Ablaufdatum"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Bestätigen & €$price zahlen"

    // complete
    override val completeProfileTitle = "Vervollständige dein Profil, um mit dem Swipen zu starten"
    override val completeProfileDescription = "Vervollständige dein Profil, um Spieler zu sehen, die zu deinem Level und deinen Interessen passen."
    override val completeProfileMaybeLater = "Vielleicht später"
    override val completeProfileAction = "Profil vervollständigen"

    // preference
    override val preferenceDetailsTitle = "Präferenz-Details"

    // follow
    override val followListFollowers = "Follower"
    override val followListFollowing = "Folge ich"
    override val followListNoResults = "Keine Ergebnisse"
    override val followListNoFollowersYet = "Noch keine Follower"
    override val followListNotFollowingAnyoneYet = "Du folgst noch niemandem"
    override val followListUnfollow = "Entfolgen"
    override val followListFollow = "Folgen"
    override val followListRemove = "Entfernen"
    override val followListDeleted = "Gelöscht"

    // top
    override val topUpTitle = "Lade dein Wallet auf"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "Du brauchst $required, um $action, aber dein Wallet enthält nur $balance."
    override val topUpChooseAmount = "Betrag wählen"
    override val topUpOr = "oder"
    override val topUpCustomAmount = "Eigener Betrag"
    override val topUpEnterAmountPlaceholder = "Betrag eingeben"
    override val topUpAction = "Aufladen"
    override val topUpFailed = "Aufladen fehlgeschlagen"

    // interactions
    override val interactionsTitle = "Interaktionen"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes neue Likes · $matches Matches"
    override val interactionsNewLikes = "Neue Likes"
    override val interactionsNoNewLikesTitle = "Noch keine neuen Likes"
    override val interactionsNoNewLikesMessage = "Wer bei dir auf Ja swipet, taucht hier auf."
    override val interactionsMatches = "Matches"
    override val interactionsNoMatchesTitle = "Noch keine Matches"
    override val interactionsNoMatchesMessage = "Swipe Ja bei jemandem, der dich schon geliked hat, um ein Match zu sichern."

    // match
    override val matchItsWord = "Es ist ein"
    override val matchWord = "Match"
    override val matchSubtitle = "Zeit, euch zu vernetzen und euer Spiel zu planen."
    override val matchKeepSwiping = "Weiter swipen"
    override val matchGoToProfile = "Zum Profil"
    override val matchYouFallback = "Du"

    // purchase
    override val purchaseCardTitle = "Diese Karte holen?"
    override val purchaseCardBuying = "Wird gekauft…"
    override val purchaseCardBuyNow = "Jetzt kaufen"

    // post
    override val postCommentsLike = "Gefällt mir"
    override val postCommentsOneLike = "1 Like"
    override fun postCommentsLikes(count: Int) = "$count Likes"
    override val postCommentsInputPlaceholder = "Nachricht schreiben…"

    // story
    override fun storySeenBy(count: Int) = "Gesehen von $count"

    // support
    override val supportTitle = "Support kontaktieren"
    override val supportIntro = "Erzähl uns, was schiefgelaufen ist oder wobei du Hilfe brauchst — wir melden uns per E-Mail bei dir."
    override val supportEmailLabel = "Deine E-Mail"
    override val supportMessageLabel = "Nachricht"
    override val supportMessagePlaceholder = "Beschreibe dein Problem…"
    override val supportErrorInvalidEmail = "Bitte gib eine gültige E-Mail-Adresse ein."
    override val supportErrorEmptyMessage = "Bitte schreibe eine Nachricht."
    override val supportErrorGeneric = "Etwas ist schiefgelaufen. Bitte versuch es erneut."
    override val supportSending = "Wird gesendet…"
    override val supportSendMessage = "Nachricht senden"
    override val supportSentTitle = "Nachricht gesendet!"
    override val supportSentMessage = "Danke für deine Nachricht — wir antworten dir bald per E-Mail."

    // person
    override val personDetailTabAbout = "Über"
    override val personDetailTabPosts = "Posts"
    override val personDetailTabAchievement = "Erfolge"
    override val personDetailAchievementsComingSoon = "Erfolge kommen bald."
    override val personDetailFollowing = "Folge ich"
    override val personDetailFollowers = "Follower"
    override val personDetailSportLabel = "Sport:"
    override val personDetailActivityLabel = "Aktivität:"
    override val personDetailLifestyleLabel = "Lifestyle:"
    override val personDetailNoPostsTitle = "Noch keine Posts"
    override val personDetailNoPostsMessage = "Dieser Spieler hat noch nichts gepostet."

    // common
    override val commonClose = "Schließen"
    override val commonDone = "Fertig"
    override val commonLoading = "Wird geladen…"
    override val commonBack = "Zurück"
    override val commonSkip = "Überspringen"

    // profile
    override val profileCardShopLoading = "Wird geladen..."
    override val profileCardShopEmpty = "Keine Karten verfügbar"
    override val profileCardShopBuy = "Kaufen"
    override val profileCardShopFree = "Kostenlos"
    override val profileFormationReservePlate = "Res"
    override val profileFormationCoach = "Trainer"
    override val profileMediaEmpty = "Noch keine Medien"
    override val profileMediaImageAlt = "Medien"
    override val profileNewsPrompt = "Was gibt's Neues?"
    override val profileNewsLoading = "Wird geladen..."
    override val profileNewsLoginRequired = "Melde dich an, um deine Posts zu sehen"
    override val profileNewsEmpty = "Noch keine Posts. Teile etwas!"
    override val profileNewsPlaceholder = "Schreib etwas..."
    override val profileNewsPosting = "Wird veröffentlicht..."
    override val profileNewsPost = "Posten"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Letzte Events"
    override val profileRecentMatchesEmptyTitle = "Noch keine Events geplant"
    override val profileRecentMatchesEmptyHint = "Such dir ein bevorstehendes Event aus und sei dabei!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Team A"
    override val profileRecentMatchesTeamB = "Team B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count Pers."
    override val profileRecentMatchesWin = "Sieg"
    override val profileRecentMatchesLoss = "Niederlage"
    override val profileRecentMatchesDraw = "Unentschieden"
    override val profileRecentMatchesSportFallback = "Sport"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "$format X $format Format"
    override fun profileRecentMatchesMembers(count: Int) = "$count Mitglieder"
    override val profileShortcutStatistic = "Statistik"
    override val profileShortcutMedia = "Medien"
    override val profileStatsChartsGoals = "Tore"
    override val profileStatsChartsAssists = "Vorlagen"
    override val profileStatsChartsPerYear = "pro Jahr"
    override val profileStatsChartsPerWeek = "pro Woche"
    override val profileStatsChartsPerMonth = "pro Monat"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Keine Daten verfügbar"
    override val profileTeamEmptyOwnTitle = "Du hast noch kein Team"
    override val profileTeamEmptyOtherTitle = "Kein Team"
    override val profileTeamEmptyCreateTeam = "Team erstellen"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Weltkarte"
    override val profileTeamMatchesEmpty = "Noch keine Matches"
    override val profileTeamMatchesUpcomingTitle = "Bevorstehende Matches"
    override val profileTeamMatchesUpcomingEmpty = "Keine bevorstehenden Matches"
    override val profileTeamMatchesVenueAlt = "Spielort"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count Teams"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total Mitglieder"
    override fun profileTeamMatchesFormat(format: Int) = "${format}x${format}-Format"
    override val profileTeamOverviewTitle = "Team-Übersicht"
    override val profileTeamOverviewClubTitle = "Fußballclub"
    override val profileTeamOverviewRating = "Bewertung"
    override val profileTeamOverviewTeamRating = "Team-Bewertung"
    override val profileTeamOverviewStatistics = "Statistiken"
    override val profileTeamOverviewWins = "Siege"
    override val profileTeamOverviewDraws = "Unentschieden"
    override val profileTeamOverviewLosses = "Niederlagen"
    override val profileSidebarTitle = "Übersicht"
    override val profileSidebarFollowing = "Folge ich"
    override val profileSidebarFollowers = "Follower"
    override val profileSidebarAchievement = "Erfolge"
    override val profileSidebarAboutYouEmpty = "Füge ein paar Worte über dich hinzu, um dein Profil vorzustellen"
    override val profileSidebarFocusActivities = "Fokus & Aktivitäten"
    override val profileSidebarSportLabel = "Sport"
    override val profileSidebarActivityLabel = "Aktivität"
    override val profileSidebarLifestyleLabel = "Lifestyle"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Folgen"
    override val profileSidebarUnfollow = "Entfolgen"
    override val profileSidebarNoInterests = "Keine Interessen hinzugefügt"
    override val profileSidebarNoInterestsBody = "Zeig anderen deine Hobbys und Sportarten."
    override val profileHubTitle = "Player Hub"
    override val profileHubYourStories = "Deine Stories"
    override val profileHubStories = "Stories"
    override val profileHubCardShopUnavailable = "Karten-Shop nicht verfügbar"
    override val profileHubCardShopTitle = "Karten-Shop"
    override val profileHubCardShopSubtitle = "Kaufe neue Karten. Definiere deinen Style."
    override val profileHubActiveBought = "Aktiv & Gekauft"
    override fun profileHubOwnedCount(count: Int) = "$count im Besitz"
    override val profileHubNoCardsYet = "Noch keine Karten"
    override val profileHubAvailableForPurchase = "Zum Kauf verfügbar"
    override val profileHubNewDesignsRegularly = "Regelmäßig neue Designs"
    override val profileHubAllCardsOwned = "Alle Karten im Besitz"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat pro $period"
    override val profileHubNoChartsTitle = "Keine Diagramme verfügbar"
    override val profileHubNoChartsBody = "Wähle oben eine Sportart, um Tore, Vorlagen, Spiele und deine übrigen Statistiken zu sehen."
    override val profileHubContentTitle = "Inhalte"
    override val profileHubLoading = "Wird geladen..."
    override val profileHubAddStory = "Story hinzufügen"
    override val profileHubAddPost = "Post hinzufügen"
    override val profileHubUserFallback = "Nutzer"
    override val profileHubNoPostsYet = "Noch keine Posts"
    override val profileHubShareFirstMoment = "Teile deinen ersten Moment"
    override val profileHubPlayerNotPosted = "Dieser Spieler hat noch nichts gepostet."
    override val profileOverviewTitle = "Spieler-Übersicht"
    override val profileOverviewPlayerIdentify = "Spieler-Identität"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "KI-Avatar"
    override val profileOverviewGoals = "Tore"
    override val profileOverviewGoalsUnit = "Tore"
    override val profileOverviewWins = "Siege"
    override val profileOverviewWinsUnit = "Siege"
    override val profileOverviewDraws = "Unentschieden"
    override val profileOverviewDrawsUnit = "Unentschieden"
    override val profileOverviewLosses = "Niederlagen"
    override val profileOverviewLossesUnit = "Niederlagen"
    override val profileOverviewAchievements = "Erfolge"
    override val profileOverviewNotFollowingAnyone = "Du folgst noch niemandem"
    override val profileOverviewComingSoon = "Kommt bald"
    override val profileAwardsEmpty = "Noch keine Auszeichnungen"
    override val awardWelcomeTitle = "Willkommens-Auszeichnung"
    override val awardTermScorerFootball = "Torschützenkönig"
    override val awardTermAssistFootball = "Top-Vorlagengeber"
    override val awardTermScorerBasketball = "Top-Scorer"
    override val awardTermAssistBasketball = "Top-Assists"
    override val awardTermScorerTennis = "Meiste Winner"
    override val awardTermAssistTennis = "Meiste Asse"
    override val awardTermScorerVolleyball = "Top-Angreifer"
    override val awardTermAssistVolleyball = "Top-Assists"
    override val awardTermScorerPadel = "Meiste Winner"
    override val awardTermAssistPadel = "Meiste Smashes"
    override val awardTermScorerGeneric = "Torschützenkönig"
    override val awardTermAssistGeneric = "Top-Vorlagengeber"
    override val awardRank1 = "1. Platz"
    override val awardRank2 = "2. Platz"
    override val awardRank3 = "3. Platz"
    override val profileOverviewAddPost = "Post hinzufügen"
    override val profileOverviewWritePlaceholder = "Schreib etwas..."
    override val profileOverviewPost = "Posten"
    override val profileOverviewLoading = "Wird geladen..."
    override val profileOverviewLoginToSeePosts = "Melde dich an, um Posts zu sehen"
    override val profileOverviewNoPostsYet = "Noch keine Posts"
    override val profileWizardLetsGo = "Los geht's!"
    override val profileWizardStepPersonalInfoTitle = "Persönliche Infos"
    override val profileWizardStepPersonalInfoDescription = "Erzähl etwas über dich, um loszulegen."
    override val profileWizardStepFocusTitle = "Fokus & Aktivitäten"
    override val profileWizardStepFocusDescription = "Wähle deine Sportarten und deinen Lifestyle"
    override val profileWizardStepCardTitle = "Erwecke deine Karte zum Leben"
    override val profileWizardStepCardDescription = "Erstelle deine visuelle Identität"
    override fun profileWizardSelectedCount(count: Int) = "$count ausgewählt"
    override val profileWizardPublicInfo = "Öffentliche Infos"
    override val profileWizardMyStyles = "Meine Styles"
    override val profileWizardSelectToGenerate = "Zum Generieren auswählen"
    override val profileWizardNoTemplates = "Noch keine Kartenvorlagen verfügbar."
    override val profileWizardActiveCards = "Aktive Profilkarten"
    override val profileWizardDragToReorder = "Zum Sortieren ziehen"
    override fun profileWizardCardCount(count: Int) = "$count ${if (count == 1) "Karte" else "Karten"}"
    override val profileWizardCreatePhoto = "Foto erstellen"
    override val profileFocusEditTitle = "Fokus & Aktivitäten"
    override val profileFocusEditDescription = "Wähle deine Sportarten und deinen Lifestyle, um deine Identität zu formen."
    override val profileFocusEditSelectedLabel = "ausgewählt"
    override val profileFocusEditClearAll = "Alle löschen"
    override val profileFocusEditSearchPlaceholder = "Attribute suchen…"
    override val profileFocusEditSportLabel = "Sport"
    override val profileFocusEditActivityLabel = "Aktivität"
    override val profileFocusEditLifestyleLabel = "Lifestyle"
    override val profileFocusEditNoMatches = "Keine Treffer"
    override val profileFocusEditPreferenceDetails = "Präferenz-Details"
    override val profileFocusEditPreferenceHint = "Optional, hilft dir aber, schneller Gleichgesinnte zu finden."
    override val profileFocusEditNoteLabel = "Notiz"
    override val profileFocusEditNotePlaceholder = "Wonach suchst du?"
    override val profileFocusEditAddDetails = "Details hinzufügen"
    override val profilePersonalEditTitle = "Persönliche Infos"
    override val profilePersonalEditDescription = "Erzähl etwas über dich, um loszulegen."
    override val profilePersonalEditFirstNameLabel = "Vorname"
    override val profilePersonalEditLastNameLabel = "Nachname"
    override val profilePersonalEditAboutMeLabel = "Über mich"
    override val profilePersonalEditBioPlaceholder = "Erzähl anderen Spielern ein bisschen über dich…"
    override val profilePersonalEditDobLabel = "Geburtsdatum"
    override val profilePersonalEditCityLabel = "Stadt"
    override val profilePersonalEditCitySearchPlaceholder = "Stadt suchen…"
    override val profilePersonalEditLanguagesLabel = "Sprachen"
    override val profilePersonalEditTypeLanguagePlaceholder = "Sprache eingeben…"
    override val profilePersonalEditAddLanguagePlaceholder = "Sprache hinzufügen…"
    override val profileEditSheetPublicInfo = "Öffentliche Infos"
    override val profileEditShellPublicInfo = "Öffentliche Infos"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Alle $count Foto(s) hinzufügen"
    override val profileCreatePostUploadFailed = "Upload fehlgeschlagen"
    override val profileCreatePostCreateFailed = "Post konnte nicht erstellt werden"
    override val profileCreatePostTitle = "Post erstellen"
    override val profileCreatePostChooseLayout = "Layout auswählen"
    override val profileCreatePostFileTooLarge = "Datei zu groß (max. 50 MB)"
    override val profileCreatePostCreating = "Wird erstellt..."
    override val profileCreatePostAddPhoto = "Foto hinzufügen"
    override val profileCreatePostContentLabel = "Post-Inhalt"
    override val profileCreatePostContentPlaceholder = "Schreib etwas zu diesem Post..."
    override val profileCreatePostCityLabel = "Stadt"
    override val profileCreatePostCityPlaceholder = "Stadtnamen eingeben..."
    override val profileCreateStoryPickPhotoFirst = "Wähle zuerst ein Foto"
    override val profileCreateStoryUploadFailed = "Upload fehlgeschlagen"
    override val profileCreateStoryCreateFailed = "Story konnte nicht erstellt werden"
    override val profileCreateStoryTitle = "Stories erstellen"
    override val profileCreateStorySubtitle = "Erstelle und teile deine Momente"
    override val profileCreateStoryFileTooLarge = "Datei zu groß (max. 30 MB)"
    override val profileCreateStoryCreating = "Wird erstellt..."
    override val profileCreateStoryDropHere = "Lege deinen Inhalt hier ab"
    override val profileCreateStoryMaxSize = " max. 30 MB"
    override val profileFollowListFollowers = "Follower"
    override val profileFollowListFollowing = "Folge ich"
    override val profileFollowListNoResults = "Keine Ergebnisse"
    override val profileFollowListUnfollow = "Entfolgen"
    override val profileFollowListFollow = "Folgen"
    override val profileFollowListRemoved = "Entfernt"
    override val profileFollowListRemove = "Entfernen"
    override val profileFollowListNotFollowingTitle = "Du folgst noch niemandem"
    override val profileFollowListNotFollowingBody = "Folge Spielern, um ihre neuesten Match-Posts, Highlights und Stories in deinem Feed zu sehen."
    override val profileFollowListDiscoverPlayers = "Spieler entdecken"
    override val profileFollowListNoFollowersTitle = "Noch keine Follower"
    override val profileFollowListNoFollowersBody = "Teile deine Match-Posts und Stories, um von der Community entdeckt zu werden."
    override val profileDialogPreferenceDetails = "Präferenz-Details"
    override val profileStoryViewersTitle = "Wer hat diese Story gesehen?"
    override val profileStoryViewersNoViews = "Noch keine Aufrufe"
    override val profileContentMobileOverview = "Übersicht"
    override val profileContentMobileFollowing = "Folge ich"
    override val profileContentMobileFollowers = "Follower"
    override val profileContentMobileAwardsComingSoon = "Auszeichnungen kommen bald"
    override val profileContentMobileRecentEvents = "Letzte Events"
    override val profileContentMobileNoEvents = "Noch keine Events geplant"
    override val profileContentMobileNoEventsBody = "Such dir ein bevorstehendes Event aus und sei dabei!"
    override val profileContentMobileResultWin = "Sieg"
    override val profileContentMobileResultDraw = "Unentschieden"
    override val profileContentMobileResultLoss = "Niederlage"
    override val profileContentMobileSportFallback = "Sport"
    override fun profileContentMobileFormat(format: Int) = "$format X $format Format"
    override fun profileContentMobileMembers(count: Int) = "$count Mitglieder"
    override val profileContentMobilePlayerHub = "Player Hub"
    override val profileContentMobileNoPostsTitle = "Noch keine Posts"
    override val profileContentMobileNoPostsOwnBody = "Teile Match-Fotos und Highlights, um dein Profil zu füllen."
    override val profileContentMobileNoPostsOtherBody = "Dieser Spieler hat noch nichts gepostet."
    override val profileContentMobileCardsUnavailable = "Karten nicht verfügbar"
    override val profileContentMobileCardsLoadFailed = "Karten konnten nicht geladen werden"
    override val profileContentMobileNoCardsAvailable = "Keine Karten verfügbar"
    override val profileContentMobileActiveBought = "Aktiv & Gekauft"
    override fun profileContentMobileOwnedCount(count: Int) = "$count im Besitz"
    override val profileContentMobileAvailableForPurchase = "Zum Kauf verfügbar"
    override val profileContentMobileNewDesigns = "Regelmäßig neue Designs"
    override val profileContentMobileNoCardsYet = "Noch keine Karten"
    override val profileContentMobileCardsTitle = "Karten"
    override val profileContentMobileAddPost = "Post hinzufügen"
    override val profileContentMobileUserFallback = "Nutzer"
    override val profileUserSheetError = "Etwas ist schiefgelaufen"
    override val profileUserSheetThisUser = "diesem Nutzer"
    override fun profileUserSheetUnfollowTitle(name: String) = "$name entfolgen?"
    override val profileUserSheetRefollowHint = "Du kannst jederzeit wieder folgen."
    override val profileUserSheetUnfollow = "Entfolgen"

    // header
    override val headerNavHome = "Start"
    override val headerNavAbout = "Über uns"
    override val headerNavServices = "Leistungen"
    override val headerNavProjects = "Projekte"
    override val headerNavContacts = "Kontakt"
    override val headerSportLabel = "Sport:"
    override val headerUserFallbackName = "Nutzer"
    override val headerNoActiveEvents = "Keine aktiven Events oder Buchungen"
    override val headerNoNotifications = "Keine Benachrichtigungen"
    override val headerYourActiveEvents = "Deine aktiven Events "
    override val headerNotificationsTitle = "Benachrichtigungen "
    override val headerMarkAllRead = "Alle als gelesen markieren"
    override val headerLoadMore = "Mehr laden"
    override val headerPendingApproval = "Bestätigung ausstehend"
    override val headerEventStatusNew = "Neu"
    override val headerEventStatusInProgress = "Läuft"
    override val headerEventStatusCompleted = "Beendet"
    override val headerEventStatusCancelled = "Abgesagt"
    override val headerBookingFallback = "Buchung"
    override val headerActionView = "Ansehen"
    override val headerActionReply = "Antworten"
    override val headerActionUnfollow = "Entfolgen"
    override val headerActionFollowBack = "Zurückfolgen"
    override val headerActionAccept = "Annehmen"
    override val headerActionDecline = "Ablehnen"
    override val headerConfirmTitle = "Bist du sicher?"
    override val headerSignOutConfirmMessage = "Du wirst auf diesem Gerät von Arena abgemeldet. Deine Daten bleiben sicher."
    override val headerSignOutConfirmLabel = "Abmelden"
    override val headerDeleteConfirmMessage = "Das Löschen deines Profils ist endgültig. Alle Credits, Momente und Statistiken werden gelöscht."
    override val headerDeleteConfirmLabel = "Löschen bestätigen"
    override val headerDeleteProfileFailed = "Dein Profil konnte nicht gelöscht werden. Bitte versuch es erneut."
    override val headerUploading = "Wird hochgeladen..."
    override val headerVisualStyle = "Visueller Stil"
    override val headerSyncWithSportType = "Mit Sportart synchronisieren"
    override val headerMyWallet = "Mein Wallet"
    override val headerSignOut = "Abmelden"
    override val headerSigningOut = "Wird abgemeldet..."
    override val headerDeleteProfile = "Profil löschen"
    override val headerRequestNoLongerAvailable = "Diese Anfrage ist nicht mehr verfügbar."
    override val headerRequestProcessFailed = "Die Anfrage konnte nicht verarbeitet werden. Versuch es erneut."
    override val headerSelectClub = "Club auswählen"
    override val headerAddClub = "Club hinzufügen"
    override val headerSwitchToPlayer = "Zu Spieler wechseln"
    override val headerLogout = "Abmelden"
    override val headerLoggingOut = "Wird abgemeldet..."
    override val headerSigningIn = "Anmeldung läuft..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "vereint"
    override val homeHeroAthletes = "Athleten"
    override val homeHeroAndTeams = "und Teams"
    override val homeHeroWorldwideFor = "weltweit für"
    override val homeSectionCreateEventsTitle = "Erstelle Events"
    override val homeSectionCreateEventsHighlight = "Events"
    override val homeSectionCreateEventsSubtitle1 = "Wähle die Sportart, lege den Zeitplan fest"
    override val homeSectionCreateEventsSubtitle2 = "und füge den Spielort hinzu."
    override val homeSectionTeammatesTitle = "Finde perfekte Mitspieler"
    override val homeSectionTeammatesHighlight = "Mitspieler"
    override val homeSectionMomentsTitle = "Teile Momente, verbinde dich mit Freunden"
    override val homeSectionMomentsHighlight = "Freunden"
    override val homeSectionStatsTitle = "Verfolge Statistiken, deinen Fortschritt & gestalte deine Karte"
    override val homeSectionStatsHighlight = "Fortschritt"
    override val homeAltEventsScreen = "Events-Bildschirm"
    override val homeAltCreateEventScreen = "Event-erstellen-Bildschirm"
    override val homeAltCreateEventModal = "Event-erstellen-Dialog"
    override val homeAltEventDetailScreen = "Event-Detail-Bildschirm"
    override val homeAltDiscoverPeople = "Leute entdecken"
    override val homeAltPlayerDiscoveryCard = "Spieler-Entdeckungskarte"
    override val homeAltMatchedInterests = "Übereinstimmende Interessen"
    override val homeAltMatchedInterestsModal = "Dialog mit übereinstimmenden Interessen"
    override val homeAltItsAMatch = "Es ist ein Match"
    override val homeAltFeedScreen = "Feed-Bildschirm"
    override val homeAltFeedPost = "Feed-Post"
    override val homeAltGameMomentsPost = "Spielmomente-Post"
    override val homeAltChatScreen = "Chat-Bildschirm"
    override val homeAltProfileOverview = "Profil-Übersicht"
    override val homeAltProfileDashboard = "Profil-Dashboard"
    override val homeAltPlayerStatsRadar = "Spieler-Statistik-Radar"
    override val homeAltPlayerStatsCard = "Spieler-Statistik-Karte"
    override val homeAltRatePerformance = "Leistung bewerten"
    override val homeAltRatePerformanceModal = "Leistung-bewerten-Dialog"
    override val homeItsYourMatch = "Es ist dein Match!"
    override val homeLabelGameMoments = "Spielmomente"
    override val homeLabelPlayerStats = "Spieler-Statistiken"
    override val homeLabelRatePerformance = "Leistung bewerten"
    override val homeFooterTagline = "Deine globale Sport-Community"
    override val homeFooterBlurb = "Finde Leute in deiner Nähe für Fußball, Tennis, Basketball, Padel oder Volleyball — mach bei spontanen Spielen und lokalen Sport-Events mit oder erstelle deine eigenen auf Arena."
    override val homeFooterAbout = "Über uns"
    override val homeFooterTerms = "Nutzungsbedingungen"
    override val homeFooterPrivacy = "Datenschutzerklärung"
    override val homeFooterPricing = "Preise"
    override val homeFooterRefund = "Rückerstattungsrichtlinie"
    override val homeFooterSupports = "Support"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "LADEN IM"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "JETZT BEI"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Analysen"
    override val dashboardTabSchedule = "Zeitplan"
    override val dashboardRatingTitle = "Bewertung"
    override val dashboardReviews = "Bewertungen"
    override val dashboardAvgDuration = "Ø Dauer"
    override val dashboardTotalRevenue = "Gesamtumsatz"
    override val dashboardTotalBookings = "Buchungen gesamt"
    override val dashboardArenaSchedule = "Arena-Zeitplan"
    override val dashboardThisWeek = "Diese Woche"
    override val dashboardAddEvent = "Event hinzufügen"
    override val dashboardTimeHeader = "Zeit"
    override val dashboardCustomerFallback = "Kunde"
    override val dashboardRevenueTitle = "Umsatz"
    override val dashboardBookingsTitle = "Buchungen"
    override val dashboardBookingStatusTitle = "Buchungsstatus"
    override val dashboardBookingHeatmapTitle = "Buchungs-Heatmap"
    override val dashboardDonutTotal = "Gesamt"
    override val dashboardBookingsTooltipPrefix = "Buchungen "
    override val dashboardStatusConfirmed = "Bestätigt"
    override val dashboardStatusCompleted = "Abgeschlossen"
    override val dashboardStatusPending = "Ausstehend"
    override val dashboardStatusUnpaid = "Unbezahlt"
    override val dashboardStatusDeclined = "Abgelehnt"
    override val dashboardNoData = "Keine Daten"
    override val dashboardDayMon = "Mo"
    override val dashboardDayTue = "Di"
    override val dashboardDayWed = "Mi"
    override val dashboardDayThu = "Do"
    override val dashboardDayFri = "Fr"
    override val dashboardDaySat = "Sa"
    override val dashboardDaySun = "So"
    override fun dashboardHourLabel(hour: Int) = "$hour Uhr"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count Buchungen"

    // arena
    override val arenaActionViewResults = "Ergebnisse ansehen"
    override val arenaActionWatchLive = "Live ansehen"
    override val arenaActionJoinNow = "Jetzt beitreten"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Neu"
    override val arenaStatusCompleted = "Beendet"
    override val arenaStatusCanceled = "Abgesagt"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total Mitglieder"
    override fun arenaMembersCount(count: Int) = "$count Mitglieder"
    override fun arenaTeamsCount(count: Int) = "$count Teams"
    override fun arenaFormat(format: String) = "$format-Format"
    override fun arenaFinalScore(score: String) = "Endstand $score"
    override fun arenaDuration(duration: String) = "Dauer $duration"
    override val arenaLoadingClubs = "Clubs werden geladen..."
    override val arenaLoadingMoreEvents = "Weitere Events werden geladen..."
    override val arenaLoadingMoreClubs = "Weitere Clubs werden geladen..."
    override val arenaLocationLabel = "Ort: "
    override val arenaAllCities = "Alle Städte"
    override val arenaCommunityAll = "Alle"
    override val arenaCommunityUnnamed = "Unbenannt"
    override val arenaTabClubs = "Clubs"
    override val arenaTabEvents = "Events"
    override val arenaEmptyTitle = "Noch keine Events geplant"
    override val arenaEmptySubtitle = "Erstelle ein Event für Match-Chat und Live-Tracking."
    override val arenaAddEvent = "Event hinzufügen"
    override val arenaNoClubsTitle = "Noch keine Clubs"
    override val arenaNoClubsSubtitle = "Clubs erscheinen hier"

    // people
    override val peopleErrorLoad = "Spieler konnten nicht geladen werden"
    override val peopleCaughtUpTitle = "Du bist auf dem neuesten Stand"
    override val peopleCaughtUpSubtitle = "Schau später wieder vorbei für mehr Spieler."
    override val peopleRefresh = "Aktualisieren"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Dein Feed ist leer"
    override val feedEmptySubtitle = "Folge Spielern, um ihre Posts und Stories hier zu sehen."
    override val feedNoCommentsTitle = "Noch keine Kommentare"
    override val feedNoCommentsSubtitle = "Sei der Erste, der kommentiert."
    override val feedMessagePlaceholder = "Nachricht schreiben..."
    override val feedLikeZero = "Gefällt mir"
    override val feedLikeOne = "1 Like"
    override fun feedLikeMany(count: Int) = "$count Likes"

    // auth
    override val authWelcomeTitle = "Willkommen in der Arena!"
    override val authWelcomeSubtitle = "Melde dich mit Google oder Apple an, um dein Profil zu erstellen, diese Seite freizuschalten und deine Sport-Reise mit uns zu starten."
    override val authAgreePrefix = "Indem du fortfährst, akzeptierst du unsere"
    override val authTerms = "Nutzungsbedingungen"
    override val authPrivacy = "Datenschutz"

    // layout
    override val layoutComingSoon = "Kommt bald"
}
